<template>
  <custom-dialog width="60%" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <div class="search">
        <el-form :inline="true">
          <el-form-item style="float: right">
            <search-input width="320px" v-model="formSearch.search" :placeholder="$t('department_user_dialog.ygxmdlzhlxdhyx')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
        </el-form>
      </div>
      <custom-table stripe type="checkbox" tableCode="portal_organAssociateUser" v-model="tableSelect" :data="organUserList" @column="setColumn" @filter="filterChange" @sort="sortChange"></custom-table>
      <div class="table-page">
        <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="warning" @click="saveOrganUser">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      tableSelect: [],
      organUserList: [],
      totalRows: 0,

      formSearch: {
        bizId: '',
        bizType: '',
        search: '',
        pageSize: 50,
        pageNum: 1,
        isAssociated: 0
      }
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.formSearch.bizId = this.model.data.bizId;
      this.formSearch.bizType = this.model.data.bizType;
      this.getOrganUserPage();
    },
    // 获取用户列表
    getOrganUserPage: function () {
      this.$getJSON(apis.DepartmentUserPage, this.formSearch).then((res) => {
        this.organUserList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getOrganUserPage();
    },
    // 保存编辑用户
    saveOrganUser: function () {
      const params = {
        departmentId: this.model.data.departmentId,
        userIds: this.tableSelect.map(t => t.userId)
      };
      this.$postJSON(apis.DepartmentUserBind, params, true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success'
        });
        this.visible = false;
        this.$emit('success');
      });
    }
  }
};
</script>

<style lang="scss"></style>
